<template>
  <section class="flex level-1"   :class="{mobile:!mobile}">   
  
    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}"  v-if="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2>Classement</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT-->
    <div class="block__classement content__classement">
      
      <!-- //TITLE MOBILE -->
      <div class="header classement entete mobile">
        <div class="left">
        <p class="subtitle">
          <PuSkeleton :loading="getIsLoading" :count="1" width='120px'>
            {{actualUser ? actualUser.name : fullname}}
          </PuSkeleton>
        </p>
        </div>
        <div class="cardScore">
          <wrapperRankingScore
          v-if="isMobile"
          titleLeft="Classement"
          titleRight="Score"
          :number='info.rank'
          :oldNumber="info.previousRank"
          :ofThem='info.totalRank'
          :scoreNumber='info.totalValue'
          :isLoad.sync = "getIsLoading"
          />
        </div>
      </div>
      <!-- //TITLE MOBILE -->

      <!-- PART MIDDLE -->
      <div class="column-middle" :class="{fullwidth:!showSideBar}">
        <div class="header entete desktop">
          <div class="left">
          <p>Classement</p>
          <p class="subtitle">
            <PuSkeleton :loading="getIsLoading" :count="1" width='120px'>
              {{actualUser ? actualUser.name : fullname}}
            </PuSkeleton>
          </p>
          </div>
          <div class="cardScore">
            <wrapperRankingScore
            v-if="!isMobile"
            titleLeft="Classement"
            titleRight="Score"
            :number='info.rank'
            :oldNumber='info.previousRank'
            :ofThem='info.totalRank'
            :scoreNumber='info.totalValue'
            :isLoad.sync = "getIsLoading"
            />
          </div>
        </div>




        <b-card no-body class="card-big"> 
            <div class="header">
              <h3>{{content.challengesClassementEvolutionTitle}}</h3>
              <b-button-group>
                <b-button @click="evolutionDate" data-name="month" class="dateChoose active">{{content.btWeek}}</b-button>
                <b-button @click="evolutionDate" data-name="sixMonth" class="dateChoose">{{content.btMonth}}</b-button>
                <b-button @click="evolutionDate" data-name="year" class="dateChoose">{{content.btYear}}</b-button>
              </b-button-group>
            </div>
            <!-- GRAPHIC -->
              <cardBig
              key="month"
              :data = evolutionData
              :period = cardToShow
              :isLoad.sync = isgraphLoading
              :type = "'concours'"
              @changePeriod = "changePeriod"
              ref="cardBig"
              class="mt-4"
              />
            <!-- GRAPHIC -->
        </b-card>

        <wrapperObjectiveListMinima  v-for="(minima,index) in dataMinima" :key="`${index}-minimas`"
                                    class="mb-4"
                                    :lists="minima"
                                    :isLoad.sync = "getIsLoading"
        />


        <wrapperObjectiveListProductions v-for="(production,index) in dataProduction" :key="`${index}-production`"
        class="mb-4"
        :lists="production"
        :isLoad.sync = "getIsLoading"
        />


        <wrapperObjectiveBonusList v-for="(bonus,index) in dataBonus" :key="`${index}-bonus`"
        class="mb-4"
        :lists="bonus"
        :places="info.totalBonus"
        :isLoad.sync = "getIsLoading"
        />


        <wrapperObjectiveList v-for="(malus,index) in dataMalus" :key="`${index}-malus`"
        class="mb-4"
        :lists="malus"
        :places="info.totalMalus"
        :isLoad.sync = "getIsLoading"
        />

        <div v-if="!showSideBar">
          <wrapperObjectiveListBonus 
          class="mb-4"
          :lists ="dataExcursion"
          :isLoad.sync = "getIsLoading"
          />
        </div>

        <b-card class="block__objectiveList" v-if="this.info.excursions">
          <header>
            <p class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='120px'>
                Excursions
              </PuSkeleton>
            </p>
          </header>
          <div class="sep"></div>
          <b-list-group>
            <b-list-group-item v-if="Object.keys(this.info.excursions)[0]">
              <div class="entete">
                <div class="title">
                  <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                    {{ Object.keys(this.info.excursions)[0] }}
                  </PuSkeleton>
                </div>
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                    {{ Object.values(this.info.excursions)[0][Object.keys(this.info.excursions)[0]] }}
                  </PuSkeleton>
                </div>
              </div>
            </b-list-group-item>

            <b-list-group-item v-if="Object.keys(this.info.excursions)[1]">
              <div class="entete">
                <div class="title">
                  <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                    {{ Object.keys(this.info.excursions)[1] }}
                  </PuSkeleton>
                </div>
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                    {{ Object.values(this.info.excursions)[1][Object.keys(this.info.excursions)[1]] }}
                  </PuSkeleton>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>


        </b-card>


        <div class="block__totalPoints">
            <p class="title">{{content.challengesClassementTotalTitle}}</p>
            <p class="number">
              <PuSkeleton :loading="getIsLoading" :count="1" width='60px'>
                {{Math.round(Math.floor(info.totalValue)).toLocaleString()}}
              </PuSkeleton>
            </p>
        </div>

      </div>
      <!-- PART MIDDLE -->



      <!-- PART RIGHT -->
      <div class="col-right column-right borderLeft" v-if="showSideBar">
        <tabsSidebarRanking
                :showAllButton = "showAllButton"
                :actualUserId = "actualUser ? actualUser.id : null"
                @newDate="changeDate($event)"
                @changeUser="changeUser($event)"
        />
      </div>
      <!-- PART RIGHT -->

    </div>
    <!-- CONTENT-->

  </section>    
</template>


<script>
import { mapGetters } from 'vuex'
import cardBig from '../../../module/card/CardBig'
import wrapperRankingScore from '../../../module/wrapper/wrapperRankingScore'
import wrapperObjectiveList from '../../../module/wrapper/wrapperObjectiveList'
import wrapperObjectiveBonusList from '../../../module/wrapper/wrapperObjectiveBonusList'
import wrapperObjectiveListProductions from '../../../module/wrapper/wrapperObjectiveListProductions'
import wrapperObjectiveListMinima from '../../../module/wrapper/wrapperObjectiveListMinima'
import wrapperObjectiveListBonus from '../../../module/wrapper/wrapperObjectiveListBonus'
import tabsSidebarRanking from '../../../module/tabs/TabsSidebarRanking'
import ChallengesMixin from '../challenges/ChallengesMixin'

import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'

export default {
  name:"challengeClassement",
    components:{ 
      cardBig,
      wrapperRankingScore,
      wrapperObjectiveList,
      wrapperObjectiveBonusList,
      wrapperObjectiveListProductions,
      wrapperObjectiveListMinima,
      wrapperObjectiveListBonus,
      tabsSidebarRanking,
    }, 
    mixins: [
      ChallengesMixin      
    ],      
    computed: {
      ...mapGetters([
        'getGeneral',
        'getChallengeSelected',
        'getFullName',
      ]),
      getIsLoading(){
        if(this.isLoading){
          return true;
        } else {
          if(this.currentUserType == 'CONFIG_NATIONAL' && !this.actualUser){
            return true;
          } else {
            return false;
          }
        }
      },
    },
    data () {
      return {
        content:"",
        fullname: '',
        info:[{}],
        dataProduction:[{}],
        dataBonus:[{}],
        dataMalus:[{}],
        dataMinima:[{}],
        dataExcursion:[{}],
        cardToShow:'month',
        showSideBar:false,
        showAllButton:false,
        evolutionData:[],
        isLoading: true,
        isgraphLoading: true,
        currentDate:null,
        actualUser:null,
        beforeUser:null,
        currentUserType:'',

        chart : {
                labels: [1500,1600,1700,1750,1800],
                datasets: [{ 
                    data: [86,114,106,106,107],
                    borderColor: "rgb(0,106,162)",
                    fill: false,
                    borderDash: [5,10],
                    pointRadius: 3
                  }, { 
                    data: [282,350,411,502,635],
                    borderColor: "rgb(128,128,128)",
                    fill: false,
                    pointRadius: 3
                  }, { 
                    data: [168,170,178,190,203],
                    borderColor: "rgb(0,106,162)",
                    fill: false,
                    pointRadius: 3
                  }
                ]
              }
      }
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      }
    },
    mounted (){
      this.getData().then(() =>{
        this.isLoading = false;
        this.isgraphLoading = false;
      });
      if(!this.isMobile){
        this.onresize();  
        window.addEventListener('resize', this.onresize)
      }
    }, 
    created (){
      this.content = this.getGeneral;
      this.fullname = this.getFullName;
      this.showSideBar = true;
      this.currentUserType = ApiAuthenticationService.getCurrentUser().type;
      this.showAllButton = ApiAuthenticationService.getCurrentUser().type === 'CONFIG_RCR' || ApiAuthenticationService.getCurrentUser().type === 'CONFIG_NATIONAL' || ApiAuthenticationService.getCurrentUser().type === 'CONFIG_INSPECTEUR';
    },
    methods : {
      goBack() {
        this.$store.dispatch('goBack');
        this.$router.push({name: "challengesHome"});  
      },
      onresize(){
        const $target = document.querySelector('.block__classement .block__totalPoints');
        const $origine = document.querySelector('.block__classement .column-middle');
        let $info = $origine && $origine.getBoundingClientRect();
        let $width = $info.width;
        $target.style.width = (parseInt($width) - parseInt(40)) + 'px';
      },
      async getData(){
        if (!this.currentDate) {
          return;
        }
        this.isLoading = true;
        this.isgraphLoading = true;
        let userId = this.actualUser ? this.actualUser.id : null;
        if(userId == null){
          userId = ApiAuthenticationService.getCurrentUser().id;
        }

        await ApiService.getConcoursApi().getResult(userId,this.getChallengeSelected, this.currentDate, this.cardToShow).then((data) => {
          this.info = data.data;
          this.dataProduction = this.info.categories;
          this.dataBonus = this.info.bonus;
          this.dataMalus = this.info.malus;
          this.dataMinima = this.info.minimas;
          this.evolutionData = this.info.historic;
          this.changePeriod(this.cardToShow);
          if(this.dataProduction == null && this.dataBonus == null && this.dataMalus == null && this.dataMinima == null && this.evolutionData == null){
            this.info = null;
          }
          this.showSideBar === false ? this.dataExcursion= this.info.excursion : '';
        });

      },
      changePeriod(data){
        this.isgraphLoading = true;
        this.cardToShow = data;
        let userId = this.actualUser ? this.actualUser.id : null;
        if(userId == null){
          userId = ApiAuthenticationService.getCurrentUser().id;
        }
        ApiService.getConcoursApi().getResult(userId,this.getChallengeSelected, this.currentDate, this.cardToShow).then((data) => {
          this.info = data.data;
          this.evolutionData = this.info.historic;
          this.isgraphLoading = false;
        });
      },
      evolutionDate($e){
        let targets = document.querySelectorAll('.dateChoose');
        targets.forEach(target => target.classList.remove('active'));
        $e.currentTarget.classList.add("active");
        this.$refs.cardBig.setData($e.currentTarget.getAttribute("data-name"));  
        this.cardToShow = $e.currentTarget.getAttribute("data-name");
      },
      changeDate(date){
        this.currentDate = date;
        this.isLoading = true;
        this.isgraphLoading = true;
        this.getData().then(() => {
          this.isLoading = false;
          this.isgraphLoading = false;
        })
      },
      changeUser(user){
        this.actualUser = user;
        this.isgraphLoading = true;
        this.isLoading = true;
        this.getData().then(() => {
          this.isgraphLoading = false;
          this.isLoading = false;
        })
      }
    },
  watch: {
      getChallengeSelected(){
        this.getData().then(() => {
          this.isLoading = false;
          this.isgraphLoading = false;
        });
      },      
  }, 
       
};
</script>
